<template>
	<div>
		<auth-container :page="page" v-if="$route.name === 'SrReaffirmStudyEdit'">
			<h2 class="mb-4">Reaffirming Study Phase for TPN {{project.projectNumber}}</h2>

			<b-tabs v-model="page.tabIndex" content-class="mt-4" class="page-nav-tabs">
				<b-tab title="Overview">
					<b-row>
						<b-col md>
							<b-table-simple small class="table-definitions">
								<b-tbody>
									<b-tr>
										<b-th>TPN</b-th>
										<b-td>
											<router-link :to="`/sr/projects/${item.projectId}`">{{project.projectNumber}} - {{project.name}}</router-link>
										</b-td>
									</b-tr>
									<b-tr>
										<b-th>Dam</b-th>
										<b-td>
											<span v-if="isNullOrEmpty(dam.id)">N/A</span>
											<router-link v-else :to="`/dams/${dam.id}`">{{dam.name}}</router-link>
										</b-td>
									</b-tr>
									<b-tr>
										<b-th>Name</b-th>
										<b-td>{{valueOrNa(item.name)}}</b-td>
									</b-tr>
									<b-tr>
										<b-th>Final Report</b-th>
										<b-td>{{item.finalReportDate | date('ddd, MMM D, YYYY', 'N/A')}}</b-td>
									</b-tr>
									<b-tr>
										<b-th>NRCS Contact</b-th>
										<b-td>{{valueOrNa(item.nrcsContact)}}</b-td>
									</b-tr>
									<b-tr>
										<b-th>Assigned A&amp;E</b-th>
										<b-td>{{valueOrNa(item.assignedAe)}}</b-td>
									</b-tr>
									<b-tr>
										<b-th>Status</b-th>
										<b-td>{{item.status | Number(2)}}%</b-td>
									</b-tr>
									<b-tr>
										<b-th>Notes</b-th>
										<b-td>{{valueOrNa(item.notes, 'None')}}</b-td>
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</b-col>
					</b-row>

					<fixed-action-bar>
						<b-button type="button" variant="primary" to="print" append target="_blank" class="mr-2">Print</b-button>
						<back-button />
						<b-button v-if="isAuthorized(roleNames.admin)" type="button" variant="danger" @click="page.delete.show = true" class="ml-auto">Delete</b-button>
					</fixed-action-bar>
				</b-tab>
				<b-tab title="Edit" v-if="!isReadOnly">
					<sr-reaffirm-study-form ref="itemForm" :item="item" :project="projectForForm" is-update @change="changesSaved"></sr-reaffirm-study-form>
				</b-tab>
				<b-tab title="Files">
					<file-manager :apiUrl="apiUrl" :files="files" :itemId="itemId" itemLabel="phase" @change="filesChanged"></file-manager>
				</b-tab>
				<b-tab title="Change Log">
					<log-viewer db-table="SrPlanReaffStudies" :item-id="itemId"></log-viewer>
				</b-tab>
			</b-tabs>

			<b-modal v-model="page.delete.show" size="md" title="Confirm delete" no-close-on-backdrop no-close-on-esc hide-header-close>
				<error-list :errors="page.delete.errors"></error-list>

				<p>
					Are you sure you want to delete this phase?
					This action is permanent and cannot be undone.
				</p>

				<div slot="modal-footer">
					<save-button type="button" :saving="page.delete.saving" @click.native="confirmDelete" text="Delete" variant="danger" />
					<b-button type="button" variant="secondary" @click="page.delete.show = false" class="ml-1">Cancel</b-button>
				</div>
			</b-modal>
		</auth-container>
		<router-view></router-view>
	</div>
</template>

<script>
	import FileManager from '@/components/FileManager';
	import SrReaffirmStudyForm from './SrReaffirmStudyForm.vue';

	export default {
		name: 'SrReaffirmStudyEdit',
		components: {
			SrReaffirmStudyForm, FileManager
		},
		data() {
			return {
				apiUrl: 'srplanreaffstudies',
				listRoute: 'SrReaffirmStudyList',
				createRoute: 'SrReaffirmStudyCreate',
				page: {
					errors: [],
					loading: false,
					showLogin: false,
					tabIndex: 0,
					delete: {
						show: false,
						errors: [],
						saving: false
					}
				},
				item: {},
				dam: {},
				project: {},
				projectForForm: {},
				files: [],
			}
		},
		async created() {
			await this.get();
		},
		watch: {
			'$route': 'get'
		},
		methods: {
			async get() {
				this.page.loading = true;
				this.page.errors = [];

				try {
					const response = await this.$http.get(`${this.apiUrl}/${this.itemId}`, this.getTokenHeader());
					this.log(response.data);
					this.item = response.data.item;
					this.dam = response.data.dam;
					this.project = response.data.project;
					this.files = response.data.files;
					this.projectForForm = response.data.projectForForm;
				} catch (error) {
					if (error.response.status === 404) {
						this.$router.push({ name: this.createRoute, query: { projectId: this.itemId } });
					}
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				this.page.loading = false;
			},
			async changesSaved() {
				await this.get();
				this.$refs.itemForm.launchToast();
				this.page.tabIndex = 1;
			},
			async filesChanged() {
				await this.get();
				this.page.tabIndex = 2;
			},
			async confirmDelete() {
				this.page.delete.errors = [];
				this.page.delete.saving = true;

				try {
					await this.$http.delete(`${this.apiUrl}/${this.itemId}`, this.getTokenHeader());
					this.page.delete.show = false;
					this.$router.push({ name: this.listRoute });
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.delete.errors = this.logError(error);
				}

				this.page.delete.saving = false;
			}
		},
		computed: {
			itemId() {
				return this.$route.params.id;
			}
		}
	}
</script>